/**
 * digitvision
 *
 * @category  digitvision
 * @package   Shopware\Plugins\DvsnFormBuilder
 * @copyright (c) 2026 digitvision
 */

import './page/dvsn-form-builder-form-list';
import './page/dvsn-form-builder-form-detail';
import './page/dvsn-form-builder-form-create';
import './component/dvsn-form-builder-form-detail-element';

import deDE from './snippet/de-DE.json';
import enGB from './snippet/en-GB.json';

const { Module } = Shopware;

Module.register('dvsn-form-builder-form', {
    type: 'plugin',
    name: 'dvsn-form-builder-form.general.name',
    title: 'dvsn-form-builder-form.general.menu-item-name',
    description: 'dvsn-form-builder-form.general.menu-item-description',
    color: '#FF68B4',
    icon: 'regular-cog',

    snippets: {
        'de-DE': deDE,
        'en-GB': enGB
    },

    routes: {
        list: {
            component: 'dvsn-form-builder-form-list',
            path: 'list'
        },
        detail: {
            component: 'dvsn-form-builder-form-detail',
            path: 'detail/:id',
            meta: {
                parentPath: 'dvsn.form.builder.form.list'
            }
        },
        create: {
            component: 'dvsn-form-builder-form-create',
            path: 'create',
            meta: {
                parentPath: 'dvsn.form.builder.form.list'
            }
        }
    },

    navigation: [{
        id: 'dvsn-form-builder',
        label: 'dvsn-form-builder.general.menu-item-name',
        color: '#FF68B4',
        position: 100,
        path: 'dvsn.form.builder.form.list',
        icon: 'regular-cog',
        parent: 'sw-content'
    }]
});
